import { type ReactNode, forwardRef } from 'react';

import { Button, type ButtonProps, makeStyles } from '@material-ui/core';

import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  root: {
    '&&': {
      minWidth: 32,
      height: 32,
      padding: theme.spacing(0.5),
      borderRadius: theme.shape.borderRadius,
      transform: 'none',
    },
    '&&:hover, &&:active': {
      transform: 'none',
    },
    '&& svg': {
      width: 18,
      height: 18,
    },
  },
  inactive: {
    '&&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

type ToolbarButtonProps = Omit<ButtonProps, 'size'> & {
  active?: boolean | null;
  children: ReactNode;
};

export const ToolbarButton = forwardRef<HTMLButtonElement, ToolbarButtonProps>(
  ({ active, className, ...props }, ref) => {
    const classes = useStyles();

    return (
      <Button
        ref={ref}
        size="small"
        variant={!!active ? 'contained' : 'text'}
        color={!!active ? 'primary' : 'default'}
        className={classNames(
          classes.root,
          { [classes.inactive]: !active },
          className,
        )}
        data-track-source-anchor="176eec237c;toolbar-button" {...props}
      />
    );
  },
);

ToolbarButton.displayName = 'ToolbarButton';
